function toSafeNumber(value) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function isSyntheticBillDiscountLine(item = {}) {
  return item?.itemCode === '__BILL_DISCOUNT_SYNTHETIC__'
}

function getLineMoneyBreakdown(item = {}) {
  if (!item || typeof item !== 'object') {
    return {}
  }

  if (!item.moneyBreakdown || typeof item.moneyBreakdown !== 'object') {
    return {}
  }

  return item.moneyBreakdown
}

function resolveLineUnitNetBeforeDiscount(item = {}) {
  const moneyBreakdown = getLineMoneyBreakdown(item)
  return toSafeNumber(moneyBreakdown.unitNetBeforeDiscount)
}

function resolveLineDiscountBeforeTax(item = {}) {
  const moneyBreakdown = getLineMoneyBreakdown(item)
  return toSafeNumber(moneyBreakdown.discountAmountBeforeTax)
}

function resolveLineNetAfterDiscount(item = {}) {
  const moneyBreakdown = getLineMoneyBreakdown(item)
  return toSafeNumber(moneyBreakdown.netAfterDiscount)
}

// Compatibility aliases for stale imports during the moneyBreakdown rollout.
function resolveLineUnitNetAfterDiscount(item = {}) {
  return resolveLineUnitNetBeforeDiscount(item)
}

function resolveLineUnitGrossBeforeDiscount(item = {}) {
  return resolveLineUnitNetBeforeDiscount(item)
}

function resolveLineDiscountGross(item = {}) {
  return resolveLineDiscountBeforeTax(item)
}

export {
  getLineMoneyBreakdown,
  isSyntheticBillDiscountLine,
  resolveLineDiscountGross,
  resolveLineDiscountBeforeTax,
  resolveLineNetAfterDiscount,
  resolveLineUnitGrossBeforeDiscount,
  resolveLineUnitNetAfterDiscount,
  resolveLineUnitNetBeforeDiscount,
}
